"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "viterbo": {
    "8ec187b3": [{
      "hkey": "e76b805a",
      "slug": "bagnaia-la-quercia",
      "name": "Bagnaia-La Quercia",
      "primary": true,
      "skipSearch": false
    }],
    "bagnaia": [{
      "hkey": "e76b805a",
      "slug": "bagnaia-la-quercia",
      "name": "Bagnaia-La Quercia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "8f118b71": [{
      "hkey": "e76b805a",
      "slug": "bagnaia-la-quercia",
      "name": "Bagnaia-La Quercia",
      "primary": true,
      "skipSearch": false
    }],
    "la-quercia": [{
      "hkey": "e76b805a",
      "slug": "bagnaia-la-quercia",
      "name": "Bagnaia-La Quercia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "viterbo"
    }],
    "56056f84": [{
      "hkey": "e329b9e0",
      "slug": "montecalvello-vallebona",
      "name": "Montecalvello-Vallebona",
      "primary": true,
      "skipSearch": false
    }],
    "montecalvello": [{
      "hkey": "e329b9e0",
      "slug": "montecalvello-vallebona",
      "name": "Montecalvello-Vallebona",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "3e6d24d1": [{
      "hkey": "e76b805a",
      "slug": "bagnaia-la-quercia",
      "name": "Bagnaia-La Quercia",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "c1097559",
      "slug": "santa-barbara",
      "name": "Santa Barbara",
      "primary": true,
      "skipSearch": false
    }],
    "periferia": [{
      "hkey": "c1097559",
      "slug": "santa-barbara",
      "name": "Santa Barbara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "viterbo"
    }],
    "ba90a430": [{
      "hkey": "d15ffc39",
      "slug": "roccalvecce-sant-angelo",
      "name": "Roccalvecce-Sant'Angelo",
      "primary": true,
      "skipSearch": false
    }],
    "roccalvecce": [{
      "hkey": "d15ffc39",
      "slug": "roccalvecce-sant-angelo",
      "name": "Roccalvecce-Sant'Angelo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "0e5d83ce": [{
      "hkey": "7d3d3253",
      "slug": "san-martino-al-cimino-tobia",
      "name": "San Martino al Cimino-Tobia",
      "primary": true,
      "skipSearch": false
    }],
    "san-martino-al-cimino": [{
      "hkey": "7d3d3253",
      "slug": "san-martino-al-cimino-tobia",
      "name": "San Martino al Cimino-Tobia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "4f6dfd50": [{
      "hkey": "0fe40aaa",
      "slug": "cappuccini-murialdo",
      "name": "Cappuccini-Murialdo",
      "primary": true,
      "skipSearch": false
    }],
    "semicentro": [{
      "hkey": "0fe40aaa",
      "slug": "cappuccini-murialdo",
      "name": "Cappuccini-Murialdo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "viterbo"
    }],
    "827dc5e3": [{
      "hkey": "7d3d3253",
      "slug": "san-martino-al-cimino-tobia",
      "name": "San Martino al Cimino-Tobia",
      "primary": true,
      "skipSearch": false
    }],
    "tobia": [{
      "hkey": "7d3d3253",
      "slug": "san-martino-al-cimino-tobia",
      "name": "San Martino al Cimino-Tobia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "viterbo"
    }]
  }
};
exports["default"] = _default;